export const isDefined = <T>(value: T | undefined | null | false): value is T =>
  value !== undefined && value !== null && value !== false;
